import React from 'react';
import PropTypes from 'prop-types';
import { useRequestData } from 'wsm-common-data';
import useFormatNumber from '../hooks/useFormatNumber';

import ColorSwatch from './ColorSwatch';
import { ALL } from '../constant';

const getSwatchColor = (facetId, value) => {
	if (value === ALL) return null;
	if (
		value &&
		['normalExteriorColor', 'normalInteriorColor'].includes(facetId)
	) {
		return value;
	}
	return null;
};

const Facet = (props) => {
	const {
		itemData: { value, label, count } = {},
		type,
		index,
		isSelected,
		onChange,
		facetId
	} = props;

	const { deviceType } = useRequestData();
	const formatNumber = useFormatNumber();
	const isDesktop = deviceType === 'DESKTOP';

	const swatchColor = getSwatchColor(facetId, value);

	return (
		<li
			className={`${type} ${facetId} ddc-span6 ${
				!isDesktop ? 'p-0' : 'mb-lg-4'
			}`}
		>
			<label className="text-left" htmlFor={`${index}-${facetId}`}>
				<input
					id={`${index}-${facetId}`}
					type={type}
					onChange={(e) => onChange(e, facetId)}
					checked={isSelected}
					value={value}
				/>
				<span className="facet-list-facet-label-text-container align-items-center">
					{swatchColor && <ColorSwatch color={swatchColor} />}
					<span className="facet-list-facet-label-text">{label}</span>
					<small className="ddc-font-size-xsmall">
						{formatNumber(count)}
					</small>
				</span>
			</label>
		</li>
	);
};

Facet.propTypes = {
	itemData: PropTypes.shape({
		label: PropTypes.string.isRequired,
		color: PropTypes.string.isRequired,
		value: PropTypes.string.isRequired,
		count: PropTypes.string.isRequired
	}).isRequired,
	type: PropTypes.string.isRequired,
	index: PropTypes.string.isRequired,
	isSelected: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
	facetId: PropTypes.string.isRequired
};

export default Facet;
